module.exports = __webpack_public_path__ + "static/img/czlo.078c7b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/czlo.jpg
// module id = WJBw
// module chunks = 2